//generate landing page
/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Landing page for the application
Author: Deimos Space UK

Version: 1.0
*/
import React, { Suspense } from 'react';
import { Container } from "reactstrap";
import TopBarLogin from '../../core/components/topbarLogin/TopBar';
import { Link } from "react-router-dom";

export default function LandingOut() {


    return (
        <div className="content-page" style={{ overflow: 'scroll' }}>
            <Suspense>
                <TopBarLogin />
            </Suspense>
            <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
                <Container className="align-center ">
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <div style={{ width: '80%' }}>
                            <h1
                                style={{ color: '#003247' }}
                            >THEMIS: Tracking the Health of the Environment and Missions in Space</h1>

                            <p>
                                The THEMIS software is a tool for “Tracking the Health of the Environment and Missions in Space”. THEMIS is a tool developed to assess the impact of a space mission on the space debris environment, and to determine the share of the capacity of Space used by the mission under analysis. It also allows the computation of the overall share of the Space capacity used by orbiting spacecraft and to analyse possible definitions of the capacity of orbital space and what its threshold should be.
                            </p>

                            <p>
                                The tool is open to the whole Space community (i.e., satellite operators, regulators, space debris experts, and general public) through this Web User Interface, which serves as the main interface for external users to access the information on the missions’ characteristics and assess their impact on the space environment. In addition, it allows the user to have an overview of the overall status of the space environment and to registered users to submit their missions for evaluation of their environmental impact both in terms of index and capacity consumption.
                            </p>

                            <p>
                                The tool was designed to raise awareness and encourage the whole Space community to pursue sustainable practices and future evolution of the space environment around the Earth. The development of the THEMIS tool was led by Politecnico di Milano in collaboration with DEIMOS UK under a contract of the European Space Agency (ESA). This project has received funding from the European Space Agency contract 4000133981/21/D/KS within the ESA's Space Safety Programme and is planned for release 2023
                            </p>
                            <p>Upon Login you can access the following resources:</p>
                            <ol>
                                <li>
                                    THEMIS model for the environmental debris index and space carrying capacity evaluation describes the modelling approach behind the computation of the debris index. “References and additional literature” contains references to the THEMIS software, and additional literature to deep into the scientific models behind the software and their definition. The full methodology and examples of applications are laid out in the references listed in THEMIS and environment assessment applications.
                                </li>
                                <li>
                                    THEMIS user manual  describes the available functionalities of the frontend, the input and the output.
                                </li>
                            </ol>
                            <h2 style={{ color: '#003247' }}>Contacts</h2>
                            <p>Contacts for queries on THEMIS use : <a href="mailto:space.debris.support@esa.int">space.debris.support@esa.int</a></p>
                            <p>Development team: Politecnico di Milano</p>
                            <p>Email: <a href="mailto:themis@polimi.it">themis@polimi.it</a></p>
                            <h2 style={{ color: '#003247' }}>Copyright  </h2>
                            <p>This website of the European Space Agency (ESA) presents prototype implementations of or methods related to, or based on, the ESA’s THEMIS space debris index. </p>

                        </div>
                    </div>
                </Container>
            </div>

            <footer style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px', height: '40px', alignItems: 'center', color: '#003247' }}>
                <Link to="/tos">
                    Terms of Service
                </Link>
                <Link to="/policy">
                    Privacy Policy
                </Link>
            </footer>
        </div>
    );
}
